import { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Dropdown, Flex, Button, Badge, Skeleton, Card } from 'antd';
// import { Menu } from 'antd'; // Закомментировано, может пригодиться
// import {
// 	ShoppingCartOutlined,
// 	HeartOutlined,
// 	UserOutlined,
// } from '@ant-design/icons'; // Закомментировано, используем SVG иконки

import {
	setSigninModalIsOpen,
	setCartPopupOpen,
	fetchMainInfo,
	// setDeliveryModalIsOpen, // Закомментировано, может пригодиться
} from 'store/slices/layoutSlice';
import { fetchCartProducts } from 'store/slices/cartSlice';
import { fetchCategoriesList } from 'store/slices/menuSlice';
import { store } from 'store/store';
import { getCustomer } from 'helpers/customer';
// import Megamenu from 'components/menu/Megamenu'; // Закомментировано, может пригодиться
import MiniCart from 'components/cart/MiniCart';
import SearchWithSuggest from 'components/form/SearchWithSuggest';
// import InlineSpace from 'components/layout/InlineSpace'; // Закомментировано, может пригодиться
import MobileHeader from './MobileHeader';
import useBreakpoint from 'hooks/useBreakpoint';
import useSmartNavigate from 'hooks/useSmartNavigate';
// import useAdditionalMenu from 'hooks/useAdditionalMenu'; // Закомментировано, может пригодиться
import useCustomer from 'hooks/useCustomer';
import { loadingStatus } from 'helpers/fetcher';
// import { formatCurrency } from 'helpers/formatter'; // Закомментировано, может пригодиться
import { getImage } from 'helpers';
import Icon from 'components/Icon';
import { SHOW_LANGUAGE_SWITCHER } from '../../../i18n';

const HeaderLayout = () => {
	const { t, i18n } = useTranslation();
	const dispatch = useDispatch();
	const cartProducts = useSelector(state => state.cart.cartProducts);
	const { data, status } = useSelector(state => state.layout.mainInfo);
	const { data: categoriesData, status: categoriesStatus } = useSelector(
		state => state.menu.categoriesList,
	);
	const location = useLocation();
	const { navigate } = useSmartNavigate();
	const { customer, setCustomer } = useCustomer();
	const { isMobile, isTablet } = useBreakpoint();
	// const { breakpoint } = useBreakpoint(); // Закомментировано, может пригодиться
	const scrollRef = useRef(null);
	const [showLeftArrow, setShowLeftArrow] = useState(false);
	const [showRightArrow, setShowRightArrow] = useState(false);
	const [catalogMenuOpen, setCatalogMenuOpen] = useState(false);
	const [selectedCategory, setSelectedCategory] = useState(null);

	const scrollItems = useMemo(() => {
		if (
			categoriesStatus !== loadingStatus.SUCCEEDED ||
			!categoriesData?.categories
		) {
			return [];
		}

		const items = [];

		const collectCategories = category => {
			const path = category.path || category.slug;
			const label = category.name || category.label || category.title;

			if (path && label) {
				items.push({ path, label });
			}

			if (category.children && category.children.length > 0) {
				category.children.forEach(collectCategories);
			}
		};

		categoriesData.categories.forEach(collectCategories);

		// Перемешиваем список, чтобы не были одинаковыми на каждом рендере
		const shuffled = [...items];
		for (let i = shuffled.length - 1; i > 0; i--) {
			const j = Math.floor(Math.random() * (i + 1));
			[shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
		}

		return shuffled;
	}, [categoriesStatus, categoriesData?.categories]);

	const checkScrollPosition = () => {
		if (scrollRef.current) {
			const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
			setShowLeftArrow(scrollLeft > 5);
			setShowRightArrow(scrollLeft < scrollWidth - clientWidth - 5);
		}
	};

	useEffect(() => {
		const scrollElement = scrollRef.current;
		if (scrollElement) {
			// Проверяем сразу и после небольшой задержки для корректной инициализации
			setTimeout(() => {
				checkScrollPosition();
			}, 100);
			scrollElement.addEventListener('scroll', checkScrollPosition);
			window.addEventListener('resize', checkScrollPosition);
		}
		return () => {
			if (scrollElement) {
				scrollElement.removeEventListener('scroll', checkScrollPosition);
			}
			window.removeEventListener('resize', checkScrollPosition);
		};
	}, [categoriesStatus, categoriesData]);
	// const additionalMenu = useAdditionalMenu(); // Закомментировано, может пригодиться

	const cartPopupOpen = useSelector(state => state.layout.cartPopupOpen);
	const totalRaw =
		cartProducts.data.totals?.find(t => t.code === 'total')?.text || '';
	// Убираем .00 из цены и добавляем ₽ если его нет
	const total =
		totalRaw.replace(/\.00\b/, '').replace(/,00\b/, '') +
		(totalRaw && !totalRaw.includes('₽') ? ' ₽' : '');

	const handleCityClick = async ({ key }) => {
		const newStoreId = Number(key);
		setCustomer({ ...customer, store_id: newStoreId });
		const path = location.pathname;
		if (path === '/page/15' && newStoreId === 1) {
			window.location.href = '/page/16';
			return;
		}
		if (path === '/page/16' && newStoreId === 0) {
			window.location.href = '/page/15';
			return;
		}
		window.location.reload();
	};

	const handleLogoClick = e => {
		e.preventDefault();
		navigate('/');
	};

	const handleSigninModalOpen = () => {
		dispatch(setSigninModalIsOpen(true));
	};

	// const handleMenuClick = ({ key, keyPath, domEvent }) => {
	// 	navigate(key);
	// }; // Закомментировано, может пригодиться

	// const handleSetDeliveryOpen = () => {
	// 	dispatch(setDeliveryModalIsOpen(true));
	// }; // Закомментировано, может пригодиться

	useEffect(() => {
		dispatch(fetchMainInfo());
		dispatch(fetchCartProducts());
		dispatch(fetchCategoriesList());
		// Повторный запрос корзины через 1.5 с, если у авторизованного пользователя корзина всё ещё пуста (гонка/сессия при загрузке)
		const t = setTimeout(() => {
			if (!getCustomer().token) return;
			const state = store.getState();
			const count =
				state.cart.cartProducts.data?.count ??
				state.cart.cartProducts.data?.products?.length ??
				0;
			if (count === 0) dispatch(fetchCartProducts());
		}, 1500);
		return () => clearTimeout(t);
	}, [dispatch]);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [location]);

	// Закрытие попапа корзины по клику вне окна
	useEffect(() => {
		if (!cartPopupOpen || isMobile || isTablet) return;
		const handleClickOutside = e => {
			if (
				e.target.closest('.cart-popover') ||
				e.target.closest('[data-cart-trigger]')
			)
				return;
			dispatch(setCartPopupOpen(false));
		};
		document.addEventListener('mousedown', handleClickOutside);
		return () => document.removeEventListener('mousedown', handleClickOutside);
	}, [cartPopupOpen, isMobile, isTablet, dispatch]);

	return isMobile || isTablet ? (
		<MobileHeader
			customer={customer}
			handleSigninModalOpen={handleSigninModalOpen}
			data={data}
			total={total}
			handleCityClick={handleCityClick}
			handleLogoClick={handleLogoClick}
			status={status}
		/>
	) : (
		<div className='white'>
			<div
				className='tn-top-rail'
				style={{
					backgroundImage: `url(${
						process.env.PUBLIC_URL || ''
					}/images/header-background.webp)`,
					backgroundSize: 'cover',
					backgroundPosition: 'center',
					backgroundRepeat: 'no-repeat',
				}}
			>
				<div className='region'>
					<Flex vertical={false} justify='flex-start' align='center'>
						<Dropdown
							trigger={['click']}
							menu={{
								items: data.cities_list,
								onClick: handleCityClick,
							}}
							overlayClassName='city-dropdown-overlay'
							dropdownRender={menu => (
								<div className='city-dropdown-menu'>{menu}</div>
							)}
						>
							{status === loadingStatus.SUCCEEDED ? (
								<Button type='text' className='city-select-button'>
									<Icon name='icon-map-marker' className='city-icon' />
									<span className='city-name'>
										{data.cities_list[customer.store_id].label}
									</span>
									<Icon name='icon-arrow-down' className='city-arrow' />
								</Button>
							) : (
								<Skeleton.Button active />
							)}
						</Dropdown>
						{status === loadingStatus.SUCCEEDED && data.telephone && (
							<a href={`tel:${data.telephone}`} className='top-rail-telephone'>
								<Icon name='icon-phone' className='phone-icon' />
								<span className='phone-link'>{data.telephone}</span>
							</a>
						)}
						{/* <InlineSpace width={10} />
					{loadingStatus.SUCCEEDED === status ? (
						<Menu
							mode='horizontal'
								items={[
									{ label: 'Каталог', key: '/catalog' },
									...additionalMenu,
								]}
							onClick={handleMenuClick}
							style={{ flex: 1, minWidth: 0 }}
						/>
					) : (
						<Skeleton.Button active block />
					)}
					<Button
						type='primary'
						size='small'
						onClick={handleSetDeliveryOpen}
						className='ml-20'
					>
						Стоимость доставки
						</Button> */}
						<div className='top-rail-menu-right'>
							{status === loadingStatus.SUCCEEDED && data.top_menu && (
								<>
									<a
										href='/page/9'
										className='top-rail-menu-item'
										onClick={e => {
											e.preventDefault();
											navigate('/page/9');
										}}
									>
										{t('header.vacancies')}
									</a>
									<a
										href='/contact'
										className='top-rail-menu-item'
										onClick={e => {
											e.preventDefault();
											navigate('/contact');
										}}
									>
										{t('header.leaveReview')}
									</a>
									<a
										href='/news'
										className='top-rail-menu-item'
										onClick={e => {
											e.preventDefault();
											navigate('/news');
										}}
									>
										{t('header.news')}
									</a>
									<a
										href='/page/20'
										className='top-rail-menu-item'
										onClick={e => {
											e.preventDefault();
											navigate('/page/20');
										}}
									>
										{t('header.certificates')}
									</a>
								</>
							)}
							{SHOW_LANGUAGE_SWITCHER && (
								<button
									type='button'
									className='lang-switch-button'
									onClick={() =>
										i18n.changeLanguage(i18n.language === 'ru' ? 'en' : 'ru')
									}
								>
									{i18n.language === 'ru' ? 'EN' : 'RU'}
								</button>
							)}
						</div>
				</Flex>
				</div>
			</div>
			<div className='rn-header region'>
				<Flex align='center' style={{ width: '100%' }}>
					<a href='/' onClick={handleLogoClick} className='header-logo'>
						<img
							src={getImage('catalog/logo_new-new-mirror.jpg')}
							style={{ width: 68 }}
							alt=''
						/>
					</a>
					<Dropdown
						open={catalogMenuOpen}
						onOpenChange={setCatalogMenuOpen}
						trigger={['click']}
						dropdownRender={() => (
							<div className='catalog-dropdown-menu'>
								<div className='catalog-menu-content'>
									<div className='catalog-menu-left'>
										{categoriesStatus === loadingStatus.LOADING ? (
											<div>{t('common.loading')}</div>
										) : categoriesStatus === loadingStatus.SUCCEEDED &&
										  categoriesData?.categories?.length > 0 ? (
											categoriesData.categories.map((category, index) => {
												// Проверяем структуру данных - может быть key вместо category_id
												const categoryId = category.category_id || category.key;
												const hasChildren =
													category.children && category.children.length > 0;
												const categoryName =
													category.name ||
													category.label ||
													category.title ||
													'';
												return (
													<div
														key={categoryId || index}
														className={`catalog-menu-item ${
															selectedCategory?.category_id === categoryId ||
															selectedCategory?.key === categoryId
																? 'active'
																: ''
														}`}
														onMouseEnter={() => {
															if (hasChildren) {
																setSelectedCategory(category);
															}
														}}
														onMouseLeave={() => {
															// Можно оставить пустым или добавить задержку перед скрытием
														}}
														onClick={() => {
															// При клике на категорию всегда переходим на страницу категории
															if (category.path || category.slug) {
																navigate(
																	`/catalog/${category.path || category.slug}`,
																);
																setCatalogMenuOpen(false);
															}
														}}
													>
														<span className='catalog-menu-item-text'>
															{categoryName}
														</span>
														{hasChildren && (
															<Icon
																name='icon-arrow-right-small'
																className='catalog-menu-item-arrow'
															/>
														)}
													</div>
												);
											})
										) : (
											<div>{t('common.noCategories')}</div>
										)}
									</div>
									{selectedCategory?.children &&
										selectedCategory.children.length > 0 && (
											<div className='catalog-menu-right'>
												{selectedCategory.children.map((child, index) => {
													const childName =
														child.name || child.label || child.title || '';
													return (
														<div
															key={child.category_id || child.key || index}
															className='catalog-menu-item'
															onClick={() => {
																if (child.path || child.slug) {
																	navigate(
																		`/catalog/${child.path || child.slug}`,
																	);
																	setCatalogMenuOpen(false);
																}
															}}
														>
															<span className='catalog-menu-item-text'>
																{childName}
															</span>
														</div>
													);
												})}
											</div>
										)}
								</div>
							</div>
						)}
					>
						<Button
							type='primary'
							data-click-key='nav:catalog'
							className={`catalog-button ${
								catalogMenuOpen ? 'catalog-button-open' : ''
							}`}
							onClick={() => setCatalogMenuOpen(!catalogMenuOpen)}
						>
							<Icon
								name={catalogMenuOpen ? 'icon-close' : 'icon-catalog'}
								className='catalog-icon'
							/>
							<span className='catalog-text'>{t('common.catalog')}</span>
						</Button>
					</Dropdown>
					<div className='search-wrapper'>
						<SearchWithSuggest />
					</div>
				</Flex>
				<Flex align='flex-start' gap={30} style={{ height: '50px' }}>
					<a
						href='/account/history'
						className='header-action-item'
						onClick={e => {
							e.preventDefault();
							if (customer.token) {
								navigate('/account/history');
							} else {
								handleSigninModalOpen();
							}
						}}
					>
						<Icon name='icon-clock' className='header-action-icon' />
						<span className='header-action-text'>{t('header.orders')}</span>
					</a>
					<a
						href='/account/wishlist'
						className='header-action-item'
						onClick={e => {
							e.preventDefault();
							if (customer.token) {
								navigate('/account/wishlist');
							} else {
								handleSigninModalOpen();
							}
						}}
					>
						<Icon name='icon-heart' className='header-action-icon' />
						<span className='header-action-text'>{t('header.favorites')}</span>
					</a>
					{!(isMobile || isTablet) ? (
						<Dropdown
							open={cartPopupOpen}
							onOpenChange={open => dispatch(setCartPopupOpen(open))}
							trigger={[]}
							overlayClassName='cart-popover-overlay'
							dropdownRender={() => (
								<Card
									className='cart-popover'
									style={{
										position: 'relative',
										width: 480,
										maxHeight: 400,
										overflowX: 'hidden',
									}}
									bodyStyle={{ padding: '24px 16px 16px 16px' }}
								>
									<div
										className='cart-popover-close-icon'
										style={{
											position: 'absolute',
											top: 6,
											right: 12,
											cursor: 'pointer',
											zIndex: 1,
										}}
										onClick={() => dispatch(setCartPopupOpen(false))}
										aria-label={t('common.close')}
									>
										<Icon name='icon-close' width={12} height={12} />
									</div>
									<div
										style={{
											maxHeight: 280,
											overflow: 'auto',
											overflowX: 'hidden',
										}}
									>
										<MiniCart
											products={cartProducts.data.products || []}
											status={cartProducts.status}
										/>
									</div>
									{cartProducts.data.count > 0 && (
										<Button
											type='primary'
											block
											className='cart-popover-btn'
											style={{ marginTop: 12 }}
											onClick={() => {
												dispatch(setCartPopupOpen(false));
												navigate('/cart');
											}}
										>
											{t('header.goToCart')}
										</Button>
									)}
								</Card>
							)}
						>
							<a
								href='/cart'
								data-cart-trigger
								className={`header-action-item ${
									cartProducts.data.count > 0
										? 'header-action-item-cart-active'
										: ''
								}`}
								onClick={e => {
									e.preventDefault();
									navigate('/cart');
								}}
							>
								<Icon
									name={
										cartProducts.data.count > 0 ? 'icon-cart-red' : 'icon-cart'
									}
									className='header-action-icon'
								/>
								<span className='header-action-text'>
									{cartProducts.data.count > 0 ? total : t('header.cart')}
								</span>
							</a>
						</Dropdown>
					) : (
						<a
							href='/cart'
							className={`header-action-item ${
								cartProducts.data.count > 0
									? 'header-action-item-cart-active'
									: ''
							}`}
							onClick={e => {
								e.preventDefault();
								navigate('/cart');
							}}
						>
							<Icon
								name={
									cartProducts.data.count > 0 ? 'icon-cart-red' : 'icon-cart'
								}
								className='header-action-icon'
							/>
							<span className='header-action-text'>
								{cartProducts.data.count > 0 ? total : t('header.cart')}
							</span>
						</a>
					)}
					<a
						href='/account'
						className='header-action-item'
						onClick={e => {
							e.preventDefault();
							if (customer.token) {
								navigate('/account');
							} else {
								handleSigninModalOpen();
							}
						}}
					>
						<Icon name='icon-user' className='header-action-icon' />
						<span className='header-action-text'>{t('header.account')}</span>
					</a>
				</Flex>
			</div>
			{status === loadingStatus.SUCCEEDED && data.top_menu && (
				<div className='rn-header-bottom region'>
					<div className='rn-header-bottom-nav'>
						{/* Акции (временно скрыто)
						<a
							href='/page/promotions'
							className='rn-header-bottom-nav-item promotion'
							onClick={e => {
								e.preventDefault();
								navigate('/page/promotions');
							}}
						>
							<Icon name='icon-percent' className='header-bottom-icon' />
							<span className='rn-header-bottom-nav-text'>Акции</span>
						</a>
						*/}
						<a
							href={`/page/${data.top_menu.about.id}`}
							className={`rn-header-bottom-nav-item ${
								location.pathname === `/page/${data.top_menu.about.id}`
									? 'active'
									: ''
							}`}
							onClick={e => {
								e.preventDefault();
								navigate(`/page/${data.top_menu.about.id}`);
							}}
						>
							<Icon name='icon-info' className='header-bottom-icon' />
							<span className='rn-header-bottom-nav-text'>{t('header.aboutCompany')}</span>
						</a>
						<a
							href={`/page/${data.top_menu.delivery.id}`}
							className={`rn-header-bottom-nav-item ${
								location.pathname === `/page/${data.top_menu.delivery.id}`
									? 'active'
									: ''
							}`}
							onClick={e => {
								e.preventDefault();
								navigate(`/page/${data.top_menu.delivery.id}`);
							}}
						>
							<Icon name='icon-shipping' className='header-bottom-icon' />
							<span className='rn-header-bottom-nav-text'>
								{t('header.deliveryAndPayment')}
							</span>
						</a>
						<a
							href='https://is.rayanhalal.ru/'
							className='rn-header-bottom-nav-item'
							target='_blank'
							rel='noopener noreferrer'
						>
							<svg className='header-bottom-icon' viewBox='0 0 20 20' aria-hidden='true'>
								<path d='M3 6.2L10 3.2L17 6.2V13.8L10 16.8L3 13.8V6.2Z' fill='none' stroke='#1C1C1C' strokeWidth='1.6' strokeLinejoin='round' />
								<path d='M3 6.2L10 9.2L17 6.2' fill='none' stroke='#1C1C1C' strokeWidth='1.6' strokeLinejoin='round' />
								<path d='M10 9.2V16.8' fill='none' stroke='#1C1C1C' strokeWidth='1.6' strokeLinejoin='round' />
							</svg>
							<span className='rn-header-bottom-nav-text'>
								{t('header.wholesale')}
							</span>
						</a>
						<a
							href='/contact'
							className={`rn-header-bottom-nav-item ${
								location.pathname === '/contact' ? 'active' : ''
							}`}
							onClick={e => {
								e.preventDefault();
								navigate('/contact');
							}}
						>
							<Icon name='icon-envelope' className='header-bottom-icon' />
							<span className='rn-header-bottom-nav-text'>{t('header.contacts')}</span>
						</a>
					</div>
					<div className='rn-header-bottom-divider'></div>
					<div className='rn-header-bottom-scroll-wrapper'>
						<div className='rn-header-bottom-scroll' ref={scrollRef}>
							{scrollItems.map((category, index) => (
								<a
									key={`${category.path}-${index}`}
									href={`/catalog/${category.path}`}
									className='rn-header-bottom-scroll-item'
									onClick={e => {
										e.preventDefault();
										navigate(`/catalog/${category.path}`);
									}}
								>
									{category.label}
								</a>
							))}
						</div>
						{showLeftArrow && (
							<img
								src={`${
									process.env.PUBLIC_URL || ''
								}/icons/icon-arrow-right.svg`}
								alt=''
								className='rn-header-bottom-scroll-arrow left'
								onClick={e => {
									e.stopPropagation();
									if (scrollRef.current) {
										scrollRef.current.scrollBy({
											left: -200,
											behavior: 'smooth',
										});
									}
								}}
							/>
						)}
						{showRightArrow && (
							<img
								src={`${
									process.env.PUBLIC_URL || ''
								}/icons/icon-arrow-right.svg`}
								alt=''
								className='rn-header-bottom-scroll-arrow'
								onClick={e => {
									e.stopPropagation();
									if (scrollRef.current) {
										scrollRef.current.scrollBy({
											left: 200,
											behavior: 'smooth',
										});
									}
								}}
							/>
						)}
					</div>
				</div>
			)}
		</div>
	);
};

export default HeaderLayout;
